import React, { FC } from "react";
import {
  RadioGroupRoot,
  RadioWrapper,
  RadioGroupItem,
  RadioGroupIndicator,
} from "./Styled";
import SvgCheck from "../icons/check";

type RadioOption = {
  label: string;
  value: string;
};

type Props = {
  currentValue: string;
  onValueChange: (value: string) => void;
  options: RadioOption[];
};

const RadioGroup: FC<Props> = ({ currentValue, onValueChange, options }) => {
  return (
    <RadioGroupRoot value={currentValue} onValueChange={onValueChange}>
      {options.map(({ label, value }) => (
        <RadioWrapper key={value}>
          <RadioGroupItem value={value} id={`option-${value}`}>
            <RadioGroupIndicator>
              <SvgCheck />
            </RadioGroupIndicator>
          </RadioGroupItem>
          <label htmlFor={`option-${value}`}>{label}</label>
        </RadioWrapper>
      ))}
    </RadioGroupRoot>
  );
};

export default RadioGroup;
